import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';

import {
  Background,
  Container,
  VideosContainer,
  Content,
  NextPage,
  NextPageContainer,
  CloseIcon,
  AlignNoVideos,
  ContainerCloseIcon,
} from './styles';
import '~/components/styles/Global.css';
import api from '~/services/api';
import Item from '~/components/pages/Training/Item';
import HeaderTraining from '~/components/pages/Training/Header';
import Loading from '~/components/layout/Loading';
import close from '~/assets/images/close.png';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { mappingHtmlToBodyVideos, indexHtmlInVideosByCreatedDate } from '~/utils/functions/training';

export default function Invoices() {
  const dispatch = useDispatch();
  const history = useHistory();

  const trainingReducer = useSelector(state => state.trainingReducer);

  const [notNext, setNotNext] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [videos, setVideos] = useState([]);
  const [noneVideo, setNoneVideo] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingVideos, setLoadingVideos] = useState(false);
  const [trainCompliance, setTrainCompliance] = useState(null);
  const roles = useSelector(state => state.rolesReducer.roles);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    dispatch({ type: 'SET_TRAINING', isTraining: true });
    dispatch({ type: 'SET_PAGE_VIDEO', page: 1 });
    dispatch({ type: 'SET_TAG_SELECTED', tagSelected: null });
    if (!trainingReducer.publicoFromHome) {
      dispatch({ type: 'SET_PUBLICO_SELECTED', publicoSelected: null });
    }
    dispatch({ type: 'SET_TITLE_SELECTED', titleSelected: null });
    async function requests() {
      await getTags();
      await getPublicsByEmail();
    }
    requests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoadingVideos(true);
    dispatch({ type: 'SET_PAGE_VIDEO', page: 1 });
    let strings = verifyStringUrl();
    async function requests() {
      await getOnlyTitle(strings.stringUrlTitle);
      await setTimeout(async () => {
        if (strings.stringUrl.slice(1, 4) === 'tag') {
          await getVideos(strings.stringUrl, 1);
        } else {
          await getVideos(strings.stringUrl);
        }
      }, 1200);
    }
    requests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    trainingReducer.tagSelected,
    trainingReducer.titleSelected,
    trainingReducer.publicoSelected,
  ]);

  useEffect(() => {
    async function fetchGetTrainingCompliance() {
      await getTrainingCompliance();
    }
    fetchGetTrainingCompliance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTrainingCompliance = async () => {
    api
    .get('/residential/store/v1/files?type=COMPLIANCE_CONCORRENCIAL', parameters)
    .then((res) => {
      setTrainCompliance(mappingHtmlToBodyVideos(res.data));
    })
    .catch((err) => {
      if (err.response.status === 404) {
        toast.error("Não foi possível carregar o treinamento Compliance Concorrencial");
      }
    })
  }

  const getStore = (userCod) => {
    api
    .get(`/residential/ultratop/v1/revendas/store?storeId=${localStorage.getItem("storeId")}`, parameters)
    .then((res) => {
      dispatch({ type: 'SET_TRAINING_STORE', revenda_cod: res.data.data[0].revenda_cod });
    })
    .catch((err) => {
      if (err.response.status === 404) {
        let body = {
          revendaTitulo: localStorage.getItem("storeName"),
          storeIdSf: localStorage.getItem("storeId")
        }
        api
        .post(`/residential/ultratop/v1/revendas`, body, parameters)
        .then((res) => {
          let body = {
            revendaCod: res.data.revenda_cod,
            userCod: localStorage.getItem("userCod")
          }
          api
          .post(`/residential/ultratop/v1/revendas/user`, body, parameters)
          .then((res) => {
            dispatch({ type: 'SET_TRAINING_STORE', revenda_cod: res.data.revenda_cod });
          })
          .catch((err) => {})
        })
        .catch((err) => {})
      }
    })
  }

  const getTags = async () => {
    api
      .get('/residential/ultratop/v1/tags', parameters)
      .then(res => {
        res.data.data.map(tag => {
          tag['selected'] = false;
        });
        dispatch({ type: 'SET_TAGS', tags: res.data.data });
      })
      .catch(err => {
      });
  };

  const getPublicsByEmail = () => {
    let url = `/residential/ultratop/v1/usuarios/codigo?userEmail=${localStorage.getItem(
      'userEmail',
    )}`;
    api
      .get(url, parameters)
      .then(res => {
        localStorage.setItem("userCod", res.data.data.user.user_cod)
        dispatch({ type: 'SET_USER_CODE', userCode: res.data.data.user.user_cod });
        getStore(res.data.data.user.user_cod)
      })
      .catch(err => {
        if (err.response.status === 404) {
          const headerError = {
            'Content-Type': 'application/json',
            access_token: localStorage.getItem('access_token'),
          };
          const parametersError = {
            headers: headerError,
          };
          api
            .post(
              '/residential/ultratop/v1/usuarios',
              {
                userEmail: localStorage.getItem('userEmail'),
                resaleName: localStorage.getItem('storeName'),
                resaleSfId: localStorage.getItem('storeId')
              },
              parametersError,
            )
            .then(async res => {
              dispatch({ type: 'SET_TRAINING_STORE', revenda_cod: res.data.revenda_cod });
              dispatch({ type: 'SET_USER_CODE', userCode: res.data.user_cod });
              if (!trainingReducer.publicoFromHome) {
                await getVideos('', 1);
              }
            })
            .catch(error => {
              toast.error(error.response.data.message);
            });
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  const verifyStringUrl = () => {
    let stringUrl = '';
    let stringUrlTitle = '';
    if (trainingReducer.tagSelected !== null) {
      stringUrl = `&tag=${trainingReducer.tagSelected.tag_titulo}`;
    }
    if (trainingReducer.publicoSelected !== null) {
      stringUrl = `${stringUrl}&publico=${trainingReducer.publicoSelected.publico_titulo}`;
      stringUrlTitle = `${stringUrlTitle}&publico=${trainingReducer.publicoSelected.publico_titulo}`;
    }
    if (trainingReducer.titleSelected !== null) {
      stringUrl = `${stringUrl}&titulo=${trainingReducer.titleSelected.video_titulo}`;
    }
    let strings = {
      stringUrl,
      stringUrlTitle,
    };
    return strings;
  };

  const mountVideoTags = (videoArray, tagsArray) => {
    let arrayTags = [];
    tagsArray.map(element => {
      arrayTags.push({ title: element.tag_titulo, isTag: true });
    });
    videoArray.map(item => {
      arrayTags.push({ title: item.video_titulo, isTag: false });
    });
    dispatch({ type: 'SET_VIDEO_TAGS', videoTags: arrayTags });
  };

  const getVideos = async (stringUrl, page) => {
    let url = `/residential/ultratop/v1/videos?size=20&page=${
      page ? page : trainingReducer.pageVideo
    }`;
    url = stringUrl === '' ? url : url + stringUrl;

    api
      .get(url, parameters)
      .then(async res => {
        setLoadingPage(false);
        setLoadingVideos(false);
        let videosFetchs = null;
        if (
          res.data.data === 'Nenhum vídeo encontrado' ||
          res.data.data.length === 0
        ) {
          setNoneVideo(true);
        } else {
          setNoneVideo(false);
          setLoadingNext(false);
          if (page ? page === 1 : trainingReducer.pageVideo === 1) {
            setVideos([]);
            let data = res.data.data;
            if (data === 'Nenhum vídeo encontrado') {
              if (trainCompliance) {
                data = [trainCompliance];
              } else {
                data = [];
              }
            } else {
              if (trainCompliance) {
                const index = indexHtmlInVideosByCreatedDate(data, trainCompliance);
                data.splice(index, 0, trainCompliance);
              }
            }
            videosFetchs = data;
            setVideos(data);
            dispatch({ type: 'SET_VIDEOS', videos: data });
            if (res.data.last_page <= page || res.data.last_page == 1) {
              setNotNext(true);
            } else {
              setNotNext(false);
            }
          } else {
            if (trainingReducer.titleSelected !== null) {
              setVideos([]);
              let data = res.data.data;
              const index = indexHtmlInVideosByCreatedDate(data, trainCompliance);
              data.splice(index, 0, trainCompliance);
              videosFetchs = data;
              dispatch({ type: 'SET_VIDEOS', videos: data });
              setVideos(data);
              setNotNext(true);
            } else {
              setVideos([]);
              let arrayVideos = videos.concat(res.data.data);
              const index = indexHtmlInVideosByCreatedDate(arrayVideos, trainCompliance);
              arrayVideos.splice(index, 0, trainCompliance);
              videosFetchs = arrayVideos;
              setVideos(arrayVideos);
              if (res.data.last_page <= page || res.data.last_page == 1) {
                setNotNext(true);
              }
              dispatch({ type: 'SET_VIDEOS', videos: arrayVideos });
            }
          }
          if (!trainCompliance){
            await api
              .get('/residential/store/v1/files?type=COMPLIANCE_CONCORRENCIAL', parameters)
              .then((res) => {
                const index = indexHtmlInVideosByCreatedDate(videosFetchs, mappingHtmlToBodyVideos(res.data));
                videosFetchs.splice(index, 0, mappingHtmlToBodyVideos(res.data));
                dispatch({ type: 'SET_VIDEOS', videos: videosFetchs });
                setVideos(videosFetchs);
              })
              .catch((err) => {
                if (err.response.status === 404) {
                  toast.error("Não foi possível carregar o treinamento Compliance Concorrencial");
                }
                return null;
              });
          }
        }
      })
      .catch(err => {
      });
  };

  const getOnlyTitle = async stringUrlTitle => {
    let url = `/residential/ultratop/v1/videos?size=1000`;
    url = stringUrlTitle === '' ? url : url + stringUrlTitle;
    api
      .get(url, parameters)
      .then(res => {
        mountVideoTags(res.data.data, trainingReducer.tags);
        dispatch({ type: 'SET_ALL_VIDEOS', allVideos: res.data.data });
      })
      .catch(err => {
      });
  };

  const goToNextPage = () => {
    setLoadingNext(true);
    dispatch({
      type: 'SET_PAGE_VIDEO',
      page: trainingReducer.pageVideo + 1,
    });
    let strings = verifyStringUrl();
    getVideos(strings.stringUrl, trainingReducer.pageVideo + 1);
  };

  return (
    <Background>
      {verifyRoles(roles, 'TREINAMENTOS') ? (
        <>
          <ContainerCloseIcon>
            <CloseIcon
              src={close}
              style={{ height: 25 }}
              alt="Ícone de fechar"
              onClick={() => history.push('/portal')}
            />
          </ContainerCloseIcon>
          <Container>
            {loadingPage ? (
              <Loading loadingColor={'blue'} />
            ) : (
              <Content>
                <HeaderTraining />
                {noneVideo ? (
                  <AlignNoVideos>
                    <span>Nenhum vídeo encontrado</span>
                  </AlignNoVideos>
                ) : (
                  <>
                    {loadingVideos ? (
                      <Loading loadingColor={'blue'} />
                    ) : (
                      <>
                        <VideosContainer>
                          {videos.map((video, index) => (
                            <Item
                              key={video.video_cod}
                              video={video}
                              index={index}
                            />
                          ))}
                        </VideosContainer>
                        <NextPageContainer content="center">
                          {notNext ? null : (
                            <NextPage onClick={() => goToNextPage()}>
                              {loadingNext ? (
                                <i
                                  className="fa fa-spinner fa-pulse fa-3x fa-fw"
                                  style={{ fontSize: '16px', color: '#000FFF' }}
                                />
                              ) : (
                                'Carregar mais...'
                              )}
                            </NextPage>
                          )}
                        </NextPageContainer>
                      </>
                    )}
                  </>
                )}
              </Content>
            )}
          </Container>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Background>
  );
}
